import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb65edc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_4 = {
  class: "hound-card__info",
  style: {"display":"flex","align-items":"center","height":"100%","gap":".5rem"}
}
const _hoisted_5 = { style: {"margin-right":".5rem"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "59",
  height: "42",
  viewBox: "0 0 59 42",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.8172 0.000976562H59L55.0976 16.9104L44.6058 23.2116L53.1597 34.3628L44.3748 41.5005L34.8358 29.0793L17.633 39.4103H0.723633C3.75538 26.2742 6.78545 13.138 9.8172 0.000976562ZM46.2923 11.3215L46.5754 10.096H17.5843L13.1491 29.3145H15.7832L46.2923 11.3215Z" })
], -1))
const _hoisted_7 = { class: "hound-card__stamina-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_ellipsis = _resolveComponent("n-ellipsis")!
  const _component_wallet_icon = _resolveComponent("wallet-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!

  return (_openBlock(), _createBlock(_component_n_card, {
    hoverable: "",
    class: "hound-card-container",
    style: {"margin-bottom":"1.5rem"},
    size: _ctx.breakpoints.sDown.matches ? 'small' : 'medium'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["hound-card avatar", `
        avatar-component-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[3]}
        avatar-neon-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[2]}
      `])
      }, [
        _createElementVNode("div", null, [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("strong", _hoisted_5, [
              _createTextVNode(" #" + _toDisplayString(_ctx.index + 1) + " ", 1),
              (_ctx.breakpoints.sDown.matches)
                ? (_openBlock(), _createBlock(_component_n_ellipsis, {
                    key: 0,
                    style: {"max-width":"6.5rem"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                  ], 64))
            ]),
            _createVNode(_component_n_tooltip, {
              trigger: "hover",
              placement: "top"
            }, {
              trigger: _withCtx(() => [
                _createVNode(_component_n_button, {
                  size: "tiny",
                  text: ""
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_n_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_wallet_icon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Owner: " + _toDisplayString(_ctx.hound.owner), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_n_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openHound(_ctx.hound.id.toString()))),
              size: "small",
              text: ""
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_n_space, {
            justify: "center",
            style: {"height":"100%"},
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_h3, { style: {"margin-bottom":"0"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_text, { type: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" SCORE: " + _toDisplayString(_ctx.hound.score), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["size"]))
}